export default __webpack_public_path__ + "static/media/chapter8.f95df639.jpg";